import { render } from "./EditPortleTemplateView.vue?vue&type=template&id=37ded410&scoped=true"
import script from "./EditPortleTemplateView.vue?vue&type=script&lang=js"
export * from "./EditPortleTemplateView.vue?vue&type=script&lang=js"

import "./EditPortleTemplateView.vue?vue&type=style&index=0&id=37ded410&scoped=true&lang=css"
import "./EditPortleTemplateView.vue?vue&type=style&index=1&id=37ded410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ded410"]])

export default __exports__